var _circle, _path, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMcd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "none"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6_12",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 5,
    width: 23,
    height: 19
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 5H4V24H27V5Z",
    fill: "#7E7AD2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6_12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5314 6.35704C22.5161 6.35704 24.1212 14.2565 24.1212 24H27.0018C27.0018 13.5068 24.1058 5 20.5336 5C18.5014 5 16.6882 7.55916 15.5021 11.5542C14.3168 7.55639 12.5029 5 10.4706 5C6.89921 5 4.00177 13.5075 4.00177 24H6.87723C6.87723 14.2565 8.48895 6.35704 10.467 6.35704C12.445 6.35704 14.0618 13.6486 14.0618 22.6423H16.9366C16.9366 13.6506 18.5483 6.35704 20.5307 6.35704",
    fill: "#7E7AD2"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMcd);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTUiIGN5PSIxNSIgcj0iMTUiIGZpbGw9Im5vbmUiLz4KPG1hc2sgaWQ9Im1hc2swXzZfMTIiIHN0eWxlPSJtYXNrLXR5cGU6bHVtaW5hbmNlIiBtYXNrVW5pdHM9InVzZXJTcGFjZU9uVXNlIiB4PSI0IiB5PSI1IiB3aWR0aD0iMjMiIGhlaWdodD0iMTkiPgo8cGF0aCBkPSJNMjcgNUg0VjI0SDI3VjVaIiBmaWxsPSIjN0U3QUQyIi8+CjwvbWFzaz4KPGcgbWFzaz0idXJsKCNtYXNrMF82XzEyKSI+CjxwYXRoIGQ9Ik0yMC41MzE0IDYuMzU3MDRDMjIuNTE2MSA2LjM1NzA0IDI0LjEyMTIgMTQuMjU2NSAyNC4xMjEyIDI0SDI3LjAwMThDMjcuMDAxOCAxMy41MDY4IDI0LjEwNTggNSAyMC41MzM2IDVDMTguNTAxNCA1IDE2LjY4ODIgNy41NTkxNiAxNS41MDIxIDExLjU1NDJDMTQuMzE2OCA3LjU1NjM5IDEyLjUwMjkgNSAxMC40NzA2IDVDNi44OTkyMSA1IDQuMDAxNzcgMTMuNTA3NSA0LjAwMTc3IDI0SDYuODc3MjNDNi44NzcyMyAxNC4yNTY1IDguNDg4OTUgNi4zNTcwNCAxMC40NjcgNi4zNTcwNEMxMi40NDUgNi4zNTcwNCAxNC4wNjE4IDEzLjY0ODYgMTQuMDYxOCAyMi42NDIzSDE2LjkzNjZDMTYuOTM2NiAxMy42NTA2IDE4LjU0ODMgNi4zNTcwNCAyMC41MzA3IDYuMzU3MDQiIGZpbGw9IiM3RTdBRDIiLz4KPC9nPgo8L3N2Zz4K";
export { ForwardRef as ReactComponent };